<template>
  <div class="loginByPwdOrCode">
    <img
      :src="imagePath.loginByQRCode"
      class="switchBtn cp"
      @click="handleSwitchLogin(1)"
    />
    <img class="luojigouHead" :src="imagePath.luojigouHead" />
    <div class="title">家校共育</div>
    <div class="mark">让儿童能力成长看得见</div>
    <!-- 登录表单 -->
    <div class="loginForm">
      <nav @click="changeForm('type', loginForm.type === 0 ? 1 : 0)">
        <span
          :class="['cp', loginForm.type === 0 ? 'selected' : 'noSelected']"
        >
          账号登录
        </span>
        <span
          :class="['cp', loginForm.type === 1 ? 'selected' : 'noSelected']"
        >
          手机号登录
        </span>
      </nav>
      <div>
        <div class="account">
          <input
            class="phone"
            type="text"
            :value="loginForm.phone"
            maxLength="11"
            :placeholder="loginForm.type === 0 ? '请输入账号' : '请输入手机号'"
            @input="changeForm('phone', $event.target.value)"
            @blur="verifyPhone"
          />
          <div class="errorReminder remind">
            {{ phoneIsTrue ? "" : "请输入正确的手机号" }}
          </div>
        </div>
        <!-- 账号密码登录 -->
        <div v-show="loginForm.type === 0">
          <div class="password">
            <input
              class="psd"
              type="password"
              maxLength="18"
              :value="loginForm.password"
              placeholder="请输入密码"
              @blur="verifyPassword"
              @input="changeForm('password', $event.target.value)"
            />
            <span
              class="forgetPsd" @click="handleSwitchLogin(3)"
            >
              忘记密码
            </span>
          </div>
          <div class="errorReminder remind">
            {{ passwordIsTrue ? "" : "请输入正确的密码" }}
          </div>
        </div>
        <!-- 手机号验证码登录 -->
        <div v-show="loginForm.type === 1">
          <div class="code">
            <input
              type="text"
              maxLength="4"
              :value="loginForm.code"
              placeholder="请输入验证码"
              @input="changeForm('code', $event.target.value)"
            />
            <span class="line"></span>
            <button
              class="forgetPsd"
              @click="getSMS"
              :disabled="state.codeDisabled"
            >
              {{ state.codeMsg }}
            </button>
          </div>
          <div class="errorReminder remind">
            {{ codeIsTrue ? "" : "请输入正确的验证码" }}
          </div>
        </div>
        <a-button
          class="loginBtn"
          type="primary"
          :loading="state.btnState"
          :disabled="state.btnState"
          @click="login"
        >
          登 录
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import imagePath from "@/utils/imagePath";

export default {
  name: "LoginByPwdOrCode", // 账号登录或手机号登录
  props: {
    // 表单数据
    loginForm: {
      type: Object,
      default: () => {
      }
    },
    // 状态
    state: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      imagePath,
      phoneIsTrue: true, // 手机号格式是否正确
      passwordIsTrue: true, // 密码是否正确
      codeIsTrue: true // 验证码是否正确
    };
  },
  methods: {
    // 验证手机号
    verifyPhone() {
      if (this.loginForm.type === 0) {
        this.phoneIsTrue = true;
        return;
      }
      const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (reg.test(this.loginForm.phone)) {
        this.phoneIsTrue = true;
      } else {
        this.phoneIsTrue = false;
      }
    },
    // 验证密码
    verifyPassword() {
      if (this.loginForm.type === 1) {
        this.passwordIsTrue = true;
        return;
      }
      const reg = /^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/;
      if (reg.test(this.loginForm.password)) {
        this.passwordIsTrue = true;
      } else {
        this.passwordIsTrue = false;
      }
    },
    // 验证验证码
    verifyCode() {
      if (this.loginForm.type === 0) {
        this.codeIsTrue = true;
        return;
      }
      const reg = /^\d{4}$/;
      if (reg.test(this.loginForm.code)) {
        this.codeIsTrue = true;
      } else {
        this.codeIsTrue = false;
      }
    },
    // 获取验证码
    getSMS() {
      const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (this.loginForm.type === 1 && myreg.test(this.loginForm.phone)) {
        this.$emit("getSMS");
      } else {
        this.verifyPhone();
        // this.$message.error("请输入正确格式的手机号！");
      }
    },
    // 登录
    login() {
      this.verifyPhone();
      this.verifyPassword();
      this.verifyCode();
      if (this.loginForm.type === 0 && this.loginForm.phone === "") return;
      if (this.loginForm.type === 1 && this.loginForm.code === "") return;
      if (this.phoneIsTrue && this.passwordIsTrue && this.codeIsTrue) {
        this.$emit("login");
      }
    },
    validate() {
    },
    // 切换登录方式
    handleSwitchLogin(val) {
      this.$emit("handleSwitchLogin", val);
    },
    // 修改表单数据
    changeForm(key, val) {
      console.log(key, "key", val, "val");
      this.$emit("changeForm", key, val);
    }
  }
};
</script>

<style scoped lang="less">
.loginByPwdOrCode {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 680px;
  height: 630px;
  background: #ffffff;
  box-shadow: 0px 6px 50px 12px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  // filter: blur(50px);

  .switchBtn {
    position: absolute;
    top: 0;
    right: 0;
    width: 110px;
    height: 110px;
  }

  .luojigouHead {
    margin-top: 34px;
    width: 132px;
    height: 132px;
  }

  .title {
    margin: -6px 0 10px;
    font-size: 26px;
    font-weight: 600;
    color: #333333;
  }

  .mark {
    font-weight: normal;
    font-size: 20px;
    color: #666666;
  }

  .loginForm {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 360px;

    nav {
      margin: 34px 0;

      .noSelected {
        font-size: 18px;
        color: #a9a9a9;
      }

      .selected {
        font-size: 22px;
        font-weight: 600;
        color: #333333;
      }

      span {
        margin-right: 20px;
      }
    }

    .phone,
    .psd {
      font-size: 18px;
      font-weight: 550;
    }

    .psd {
      letter-spacing: 6px;
    }

    input,
    .loginBtn {
      padding-left: 20px;
      width: 360px;
      height: 60px;
      line-height: 60px;
      background: #f6f6f6;
      border-radius: 30px;
      border-color: #ffffff;
      font-size: 16px;
      box-sizing: border-box;
    }

    .loginBtn {
      margin-top: 26px;
    }

    .password,
    .code {
      position: relative;
      height: 60px;

      .line {
        position: absolute;
        top: 50%;
        right: 110px;
        width: 1px;
        height: 25px;
        background-color: #cbcbcb;
        transform: translate(0, -50%);
      }

      .forgetPsd {
        position: absolute;
        top: 50%;
        right: 20px;
        font-size: 14px;
        color: #ff6f5b;
        background-color: #f6f6f6;
        transform: translate(0, -50%);
        cursor: pointer;
      }
    }

    .loginBtn {
      font-size: 26px;
      color: #ffffff;
      background: #ff6f5b;
    }

    .alert {
      color: rgb(47, 255, 82);
    }

    .alert-danger {
      color: rgba(255, 0, 0, 0.719);
    }

    input:focus {
      border: 2px solid #ff6f5b;
    }
  }
}

::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  font-size: 16px;
  letter-spacing: 0px;
  font-weight: 400;
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-size: 16px;
  letter-spacing: 0px;
  font-weight: 400;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 16px;
  letter-spacing: 0px;
  font-weight: 400;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  font-size: 16px;
  letter-spacing: 0px;
  font-weight: 400;
}
</style>
